export enum TimezoneStatus {
  SUCCESS,
  PERMISSION_DENIED,
  POSITION_UNAVAILABLE,
  ERROR
}
